/**
 * ContentHubSearch Page
 * Search results page for Content Hub
 */

import { SearchResultsPage } from '@/components/content-hub'

export default function ContentHubSearch() {
  return <SearchResultsPage />
}
